export default function gettingDetails(key) {
  let value = sessionStorage.getItem(key);

  // If not found in sessionStorage, fallback to localStorage
  if (!value) {
    value = localStorage.getItem(key);
  }


  if (value) {
    return value;
  } else {
    return null;
  }
}
